import * as classnames from 'classnames';
import * as React from 'react';

import { Link } from 'react-router-dom';

import { Logo } from 'components/Logo';
import { Portal } from 'components/Portal';

import './LayoutHeader.scss';

interface LayoutHeaderProps {
  actionHandler: MSExecAtPriorityFunctionCallback;
  actionIcon: string;
  modifier?: 'without-border';
  showLogo?: boolean;
  toolbar?: JSX.Element;
}

export class LayoutHeader extends React.Component<LayoutHeaderProps, {}> {
  componentDidMount() {
    if (this.props.toolbar) {
      setTimeout(() => this.handleStickyHeader(), 0);
    }
  }

  render() {
    const { modifier, toolbar } = this.props;
    const classNameModifier = modifier && 'layout-header--' + modifier;
    const classNameSticky = !toolbar && 'layout-header--sticky';
    return (
      <Portal elementId="layout__header-extension">
        {this.getLayoutHeader('layout-header', classnames(classNameModifier, classNameSticky))}

        {!toolbar && <section id="layout-header__gap"/>}

        {toolbar && this.getLayoutHeader('layout-header__sticky')}
      </Portal>
    );
  }

  get layoutHeaderLogo() {
    return this.props.showLogo && (
      <Link to="/">
        <Logo className="layout-header__logo"/>
      </Link>
    );
  }

  private getLayoutHeader(idName: string, className?: string) {
    const { children, toolbar } = this.props;
    return (
      <header id={idName} className={className}>
        <div className="layout-header__desktop-action">
          {this.getActionButton()}
        </div>

        <div className="layout-header__content o-container">
          {this.getActionButton('layout-header__action-button-mobile')}
          {this.layoutHeaderLogo}

          {children}
        </div>

        <div className="o-container">{toolbar}</div>
      </header>
    );
  }

  private getActionButton(className?: string) {
    const { actionHandler, actionIcon } = this.props;
    return (
      <span
        className={classnames('layout-header__action-button', className)}
        onClick={actionHandler}
      >
        <i className={classnames('o-icon-action', actionIcon)}/>
      </span>
    );
  }

  private handleStickyHeader() {
    const stickyHeader = document.getElementById('layout-header__sticky');
    if (stickyHeader) {
      let counterOfSticky = 0;
      let lastTop = 0;

      document.addEventListener('scroll', () => {
        const top = document.documentElement.scrollTop || document.body.scrollTop;
        const numberOfMinimumCounter = 12;

        if (top < lastTop) {
          if (counterOfSticky <= numberOfMinimumCounter) {
            counterOfSticky++;
          }
        } else {
          counterOfSticky = 0;
        }

        if (counterOfSticky > numberOfMinimumCounter) {
          stickyHeader.classList.add('layout-header__sticky--full');
        } else {
          stickyHeader.classList.remove('layout-header__sticky--full');
        }

        const layoutHeaderContentHeight = 60;
        if (top > layoutHeaderContentHeight || (counterOfSticky > numberOfMinimumCounter && top > 0)) {
          stickyHeader.classList.add('u-visible--block');
        } else {
          stickyHeader.classList.remove('u-visible--block');
        }
        lastTop = top;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/LayoutHeader/LayoutHeader.tsx